<template>
  <div :class="['saved-card', savedCard?.walletType]">
    <span class="card-number">
      {{ paymentMethodLabel }}
    </span>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "SavedPaymentMethod",
  computed: {
    ...mapGetters({
      savedCard: "payment/savedCard",
    }),
    paymentMethodLabel() {
      if (this.savedCard?.walletType === "google_pay") return "Google Pay";

      if (this.savedCard?.walletType === "apple_pay") return "Apple Pay";

      return `XXXX XXXX XXXX ${this.savedCard.lastFourDigits || ""}`;
    },
  },
};
</script>
<style lang="scss" scoped>
.saved-card {
  width: 100%;
  padding: 13px 16px 13px 50px;
  border-radius: 4px;
  border: solid 1px var(--lineSepaCol);
  background-color: var(--readOnlyTxtBgCol);
  font-size: 14px;
  line-height: 1.43;
  color: var(--primaryTextCol);
  background-image: url("../../assets/cardIcon.svg");
  background-repeat: no-repeat;
  background-position: center left 16px;

  &.google_pay {
    background-image: url("../../assets/gpay.svg");
  }

  &.apple_pay {
    background-image: url("../../assets/apple.svg");
  }
}
</style>
